export const version = "1.0.2-daily-20260522-0";
export const channel = "daily";
export const gitcommit = "587311f4e";
